import { render, staticRenderFns } from "./QADetail.vue?vue&type=template&id=dd1cebd0&scoped=true"
import script from "./QADetail.vue?vue&type=script&lang=js"
export * from "./QADetail.vue?vue&type=script&lang=js"
import style0 from "./QADetail.vue?vue&type=style&index=0&id=dd1cebd0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd1cebd0",
  null
  
)

export default component.exports